import {
    FirewallService,
    HeaderAction,
    HeaderContextMenuAction,
    HeaderContextMenuActionsProvider,
    HEADER_ACTION_SETTINGS
} from '@surgetech-eu/core'
import { Inject, Injectable } from '@angular/core'
import { zip, of, Observable } from 'rxjs'

@Injectable()
export class HeaderMenuActionsProvider implements HeaderContextMenuActionsProvider {
    constructor(
        @Inject('surge.core.firewall') private firewall: FirewallService,
        @Inject('eu.surgetech.front.ewc.ActiveHeaderActions') private activeHeaderActions: string[]
    ) {}

    public getActions(): Observable<HeaderAction[]> {
        if (this.activeHeaderActions.length === 0) {
            return of([])
        }

        const active = action => {
            return this.activeHeaderActions.includes(action)
        }

        return new Observable(observer => {
            return zip(
                active(HEADER_ACTION_SETTINGS) ? this.firewall.allow('manageHandbook') : of(false),
                this.firewall.allow('uploadDamMedia'),
                this.firewall.allow('manageDamUsers'),
                this.firewall.allow('manageApiUsers')
            ).subscribe(
                result => {
                    const actions: HeaderContextMenuAction[] = []
                    const settings = {
                        title: 'Settings',
                        children: []
                    }
                    if (result[0] && result[2]) {
                        settings.children.push({ route: ['/', 'settings', 'libraries'], title: 'Libraries' })
                    }
                    if (result[2]) {
                        settings.children.push({ route: ['/', 'dam', 'season-dates'], title: 'Season dates' })
                        settings.children.push({ route: ['/', 'dam', 'user-group'], title: 'User group' })
                        settings.children.push({ route: ['/', 'dam', 'users'], title: 'Users' })
                        settings.children.push({ route: ['/', 'dam', 'view-ranking'], title: 'View ranking' })
                        settings.children.push({ route: ['/', 'dam', 'master-image'], title: 'Master image' })
                    }
                    if (result[3]) {
                        settings.children.push({ route: ['/', 'dam', 'api-user-management'], title: 'Api User Management' })
                        settings.children.push({ route: ['/', 'dam', 'api-permission-management'], title: 'Permission Management' })
                    }
                    if (settings.children.length > 0) {
                        actions.push(settings)
                    }

                    observer.next(actions)
                },
                e => observer.error(e),
                () => observer.complete()
            )
        })
    }
}
